// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { jsx } from "@emotion/core";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import animateScrollTo from "animated-scroll-to";
import { Typeset, Typepad, BgColor, PageContainer } from "../Partials/Typeset";
import { WorkFracturedVeil } from "../Pages/Work/FracturedVeil.js";
import { WorkManimal } from "../Pages/Work/Manimal.js";
import { WorkPcg } from "../Pages/Work/Pcg.js";
import { WorkKuaa } from "../Pages/Work/Kuaa.js";
import { WorkMcgee } from "../Pages/Work/Mcgee.js";
import { WorkKlymit } from "../Pages/Work/Klymit.js";
import { WorkOgg } from "../Pages/Work/Ogg.js";
import { WorkBlackDiamond } from "../Pages/Work/BlackDiamond.js";
import { WorkBlackDiamondS } from "../Pages/Work/BlackDiamondS.js";
import { WorkOlympic } from "../Pages/Work/Olympic.js";
import { WorkChapul } from "../Pages/Work/Chapul.js";
import { WorkLeaf } from "../Pages/Work/Leaf.js";
import { WorkMbj } from "../Pages/Work/Mbj.js";
import { WorkSharpko } from "../Pages/Work/Sharpko.js";
import { WorkTucker } from "../Pages/Work/Tucker.js";
import { WorkSmmgs } from "../Pages/Work/Smmgs.js";
import { Footer } from "../Partials/Ui";

import { Button, ButtonSecondary, ButtonSet } from "../Partials/Button";
import { sizes, expandValue } from "../../helpers/theme";
import { work } from "../../helpers/data";
import { unslugify } from "../../helpers/utils";

var $ = require("jquery");
var urlParams = new URLSearchParams(window.location.search);

export class PageWork extends React.Component {
  componentWillUpdate() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 0,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 0
    };

    let pParam = urlParams.get("p");

    // if p is set, scroll to that area
    if (pParam) {
      animateScrollTo(
        document.querySelector("[data-name=" + pParam + "]"),
        options
      );
    } else {
      animateScrollTo(0, options);
    }

    $("#Top").addClass("Banished");
  }

  render() {
    let filter = "";
    if (this.props.match.params.tag) {
      filter = unslugify(this.props.match.params.tag);
    }
    return (
      <PageContainer>
        <Helmet>
          <title>Portfolio - Jesse Stewart | User Interface Designer</title>
          <meta
            itemprop="description"
            content="The Portfolio of Jesse Stewart, Staff Software Engineer and UX/UI Designer in East Lansing, Michigan."
          />
          <link rel="canonical" href="https://jessestewart.com/" />
        </Helmet>
        {filter ? (
          <div css={{ minHeight: "80vh" }}>
            <Typepad pageTop>
              <Typeset>
                <h1 style={{ marginBottom: 0 }}>Work</h1>
                <h4 className="line">{filter}</h4>
                <p
                  className="lead"
                  style={{ marginBottom: expandValue(sizes.space) }}
                >
                  Here is an example of work tagged as{" "}
                  <em>&lsquo;{filter}&rsquo;</em>.
                </p>
                <ButtonSet>
                  <Link to="/">
                    <ButtonSecondary>View All Work</ButtonSecondary>
                  </Link>
                </ButtonSet>
              </Typeset>
            </Typepad>
          </div>
        ) : (
          <div css={{ minHeight: "80vh" }}>
            <Typepad pageTop>
              <Typeset>
                <h1 className="line">Work</h1>
                <p
                  className="lead"
                  style={{ marginBottom: expandValue(sizes.space) }}
                >
                  My core competencies are{" "}
                  <Link to="/t/ReactJS" className="no-break">
                    Software Development
                  </Link>
                  ,{" "}
                  <Link to="/t/eCommerce" className="no-break">
                    eCommerce
                  </Link>
                  ,{" "}
                  <Link to="/t/UX%20Design" className="no-break">
                    User Experience
                  </Link>
                  , and{" "}
                  <Link to="/t/UI%20Design" className="no-break">
                    User Interface Design
                  </Link>
                  . I'm currently employed as a <em>Staff Software Engineer</em> at{" "}
                  <a href="http://www.wgu.edu">Western Governors University</a>.
                </p>
                <ButtonSet>
                  <Link to="/resume">
                    <Button>Resume</Button>
                  </Link>
                </ButtonSet>
              </Typeset>
            </Typepad>
          </div>
        )}

        {filter
          ? work
              .filter(work => work.tags.includes(filter))
              .map((work, index) => (
                <div key={"Work_" + index}>
                  {work.component === "WorkFracturedVeil" && (
                    <WorkFracturedVeil />
                  )}
                  {work.component === "WorkPcg" && <WorkPcg />}
                  {work.component === "WorkKuaa" && <WorkKuaa />}
                  {work.component === "WorkMcgee" && <WorkMcgee />}
                  {work.component === "WorkKlymit" && <WorkKlymit />}
                  {work.component === "WorkOgg" && <WorkOgg />}
                  {work.component === "WorkBlackDiamond" && (
                    <WorkBlackDiamond />
                  )}
                  {work.component === "WorkBlackDiamondS" && (
                    <WorkBlackDiamondS />
                  )}
                  {work.component === "WorkOlympic" && <WorkOlympic />}
                  {work.component === "WorkChapul" && <WorkChapul />}
                  {work.component === "WorkLeaf" && <WorkLeaf />}
                  {work.component === "WorkMbj" && <WorkMbj />}
                  {work.component === "WorkSharpko" && <WorkSharpko />}
                  {work.component === "WorkTucker" && <WorkTucker />}
                  {work.component === "WorkSmmgs" && <WorkSmmgs />}
                  {work.component === "WorkManimal" && <WorkManimal />}
                </div>
              ))
          : work.map((work, index) => (
              <div key={"Work_" + index}>
                {work.component === "WorkFracturedVeil" && (
                  <WorkFracturedVeil />
                )}
                {work.component === "WorkPcg" && <WorkPcg />}
                {work.component === "WorkKuaa" && <WorkKuaa />}
                {work.component === "WorkMcgee" && <WorkMcgee />}
                {work.component === "WorkKlymit" && <WorkKlymit />}
                {work.component === "WorkOgg" && <WorkOgg />}
                {work.component === "WorkBlackDiamond" && <WorkBlackDiamond />}
                {work.component === "WorkBlackDiamondS" && (
                  <WorkBlackDiamondS />
                )}
                {work.component === "WorkOlympic" && <WorkOlympic />}
                {work.component === "WorkChapul" && <WorkChapul />}
                {work.component === "WorkLeaf" && <WorkLeaf />}
                {work.component === "WorkMbj" && <WorkMbj />}
                {work.component === "WorkSharpko" && <WorkSharpko />}
                {work.component === "WorkTucker" && <WorkTucker />}
                {work.component === "WorkSmmgs" && <WorkSmmgs />}
                {work.component === "WorkManimal" && <WorkManimal />}
              </div>
            ))}

        {filter && (
          <BgColor>
            <Typepad>
              <Typeset>
                <p
                  className="text-lg"
                  style={{ marginBottom: expandValue(sizes.space) }}
                >
                  Viewing portfolio items tagged as{" "}
                  <em>&lsquo;{filter}&rsquo;</em>.
                </p>
                <ButtonSet>
                  <Link to="/">
                    <ButtonSecondary>View All Work</ButtonSecondary>
                  </Link>
                </ButtonSet>
              </Typeset>
            </Typepad>
          </BgColor>
        )}

        <Footer />
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Work.js